import classNames from 'classnames';
import React, { useContext } from 'react';
import { ToolbarContext } from 'ricos-context';
import { s as styles } from '../url-link-button-c14ae166.js';
import '../style-inject.es-e7b07dd7.js';

const AnchorLinkButton = ({ toolbarItem }) => {
  var _a;
  const { t } = useContext(ToolbarContext);
  const dataHook = (_a = toolbarItem.presentation) == null ? void 0 : _a.dataHook;
  return /* @__PURE__ */ React.createElement("div", { className: styles.toolbarUrlContainer }, /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-hook": dataHook,
      className: classNames(styles.toolbarUrl, styles.toolbarUrlAnchor),
      onClick: (e) => {
        e.preventDefault();
        toolbarItem.commands.click();
      },
      type: "button"
    },
    t("LinkTo_Toolbar_GoTo")
  ));
};

export { AnchorLinkButton };
//# sourceMappingURL=anchor-link-button.js.map
